import setup from './moduleSetup';

export default {
    name: 'sideMenuItems',
    before: [],
    after: [],
    setup,
};
